export default {
  forgot_password: {
    title: 'Restablecer contraseña',
    required: '@:validation.required',
    incorrect_email_address: '@:validation.email_format',
    double_check_text: '@:login.double_check_text',
    forgot_password: 'Olvidé la contraseña',
    password_reset_text: 'Ingrese su dirección de correo electrónico. Recibirá un correo electrónico de confirmación para restablecer su contraseña.',
    submit: 'Enviar',
    mail_address: 'Correo electrónico',
    input_label: '@:settings.user.email',
  },
}
